var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoadmap({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.696 7.656H3.924A1.939 1.939 0 011.988 5.72c0-1.067.868-1.935 1.936-1.935h4.858a.494.494 0 100-.988H3.924A2.927 2.927 0 001 5.719a2.927 2.927 0 002.924 2.925h7.772c1.068 0 1.936.869 1.936 1.937a1.938 1.938 0 01-1.936 1.935h-4.9a.494.494 0 000 .988h4.9a2.927 2.927 0 002.924-2.923 2.927 2.927 0 00-2.924-2.925z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.854 9.559a2.08 2.08 0 00-2.078 2.078c0 1.769 1.658 3.447 1.729 3.518a.494.494 0 00.698 0c.07-.07 1.73-1.75 1.73-3.518a2.08 2.08 0 00-2.08-2.078zm0 4.5c-.426-.526-1.09-1.495-1.09-2.422a1.092 1.092 0 012.18 0c0 .926-.664 1.896-1.09 2.422zM11.723 6.74a.492.492 0 00.35-.144c.07-.07 1.73-1.749 1.73-3.518A2.081 2.081 0 0011.723 1a2.08 2.08 0 00-2.078 2.078c0 1.769 1.659 3.448 1.73 3.518a.492.492 0 00.348.145zm0-4.752c.602 0 1.092.489 1.092 1.09 0 .927-.665 1.896-1.091 2.422-.427-.526-1.091-1.495-1.091-2.422 0-.601.49-1.09 1.09-1.09z",
    fill: "currentColor"
  })));
}

export default SvgRoadmap;